(function () {
    'use strict';

    if (window.BcGuide) return;

    const Media = window.BcThemedMedia;
    let dialog = null;
    let video = null;
    let catalogue = {};
    let currentId = null;
    let pending = null;

    function readCatalogue() {
        const el = document.getElementById('guide-catalogue');
        if (!el) return {};
        try {
            return JSON.parse(el.textContent) || {};
        } catch (_) {
            return {};
        }
    }

    function hashSync() {
        return !!dialog && dialog.hasAttribute('data-hash-sync');
    }

    function pauseReplay() {
        const replay = window.Replay;
        if (!replay || !replay.State || !replay.State.isPlaying) return;
        if (replay.Playback && typeof replay.Playback.stopAutoPlay === 'function') {
            replay.Playback.stopAutoPlay();
        }
    }

    function captionsTrack(src) {
        const track = document.createElement('track');
        track.kind = 'captions';
        track.srclang = 'en';
        track.label = 'English';
        track.src = src;
        return track;
    }

    function load(entry, next) {
        const themed = Media.isDark() ? entry.dark : entry.light;
        pending = next;
        video.querySelectorAll('source, track').forEach(function (el) {
            el.remove();
        });
        video.poster = themed.poster;
        video.append(
            Media.source(themed.webm, 'video/webm'),
            Media.source(themed.mp4, 'video/mp4'),
            captionsTrack(entry.captions),
        );
        video.load();
    }

    function unload() {
        pending = null;
        video.pause();
        video.querySelectorAll('source, track').forEach(function (el) {
            el.remove();
        });
        video.removeAttribute('poster');
        video.load();
    }

    function setHash(id) {
        if (!hashSync() || !window.history || !window.history.replaceState) return;
        const base = window.location.pathname + window.location.search;
        window.history.replaceState(null, '', id ? base + '#' + id : base);
    }

    function open(id) {
        const entry = catalogue[id];
        if (!dialog || !entry) return false;
        pauseReplay();
        currentId = id;
        dialog.querySelector('.guide-player-title').textContent = entry.title;
        dialog.querySelector('.guide-player-dur').textContent = entry.duration;
        load(entry, { at: 0, play: true });
        if (!dialog.open) dialog.showModal();
        video.focus();
        setHash(id);
        return true;
    }

    function togglePlay() {
        if (video.paused) Media.play(video);
        else video.pause();
    }

    function onKeydown(e) {
        e.stopPropagation();
        if (e.key !== ' ' || e.target === video) return;
        if (e.target.closest('button, a, input, select, textarea')) return;
        e.preventDefault();
        togglePlay();
    }

    function close() {
        if (dialog && dialog.open) dialog.close();
    }

    function onClosed() {
        currentId = null;
        unload();
        setHash(null);
    }

    function onTheme() {
        if (!currentId || !dialog.open) return;
        load(catalogue[currentId], {
            at: pending ? pending.at : video.currentTime,
            play: pending ? pending.play : !video.paused,
        });
    }

    function idFromHash() {
        try {
            return decodeURIComponent(window.location.hash.slice(1));
        } catch (_) {
            return '';
        }
    }

    function openFromHash() {
        const id = idFromHash();
        if (catalogue[id]) {
            if (id !== currentId) open(id);
        } else if (!id) {
            close();
        }
    }

    function onClick(e) {
        const trigger = e.target.closest && e.target.closest('[data-guide]');
        if (!trigger || !catalogue[trigger.dataset.guide]) return;
        e.preventDefault();
        e.stopPropagation();
        open(trigger.dataset.guide);
    }

    function init() {
        catalogue = readCatalogue();
        dialog = document.getElementById('guidePlayer');
        if (!dialog) return;
        video = dialog.querySelector('.guide-player-video');

        video.addEventListener('loadedmetadata', function () {
            if (!pending) return;
            const next = pending;
            pending = null;
            if (next.at) video.currentTime = next.at;
            if (next.play) Media.play(video);
        });
        dialog.addEventListener('close', onClosed);
        dialog.addEventListener('click', function (e) {
            if (e.target === dialog || e.target.closest('[data-guide-close]')) close();
        });
        dialog.addEventListener('keydown', onKeydown);
        document.addEventListener('click', onClick, true);
        Media.onThemeChange(onTheme);

        if (hashSync()) {
            window.addEventListener('hashchange', openFromHash);
            openFromHash();
        }
    }

    window.BcGuide = {
        open: open,
        close: close,
        current: function () {
            return currentId;
        },
    };

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
    else init();
})();
